import Image from "next/image";
import { useEffect, useState } from "react";
import { getPlaceImageUrl, PLACE_IMAGE_FALLBACK } from "@/utils/media";

const PlaceImage = ({
  media,
  src,
  variant = "thumbnail",
  fallbackSrc = PLACE_IMAGE_FALLBACK,
  onError,
  ...props
}) => {
  const resolvedSrc =
    src || getPlaceImageUrl(media, { variant, fallback: fallbackSrc });
  const [imageSrc, setImageSrc] = useState(resolvedSrc || fallbackSrc);

  useEffect(() => {
    setImageSrc(resolvedSrc || fallbackSrc);
  }, [resolvedSrc, fallbackSrc]);

  return (
    <Image
      {...props}
      src={imageSrc}
      onError={(event) => {
        onError?.(event);
        if (imageSrc !== fallbackSrc) setImageSrc(fallbackSrc);
      }}
    />
  );
};

export default PlaceImage;
